export default __webpack_public_path__ + "static/media/Roboto-Regular.97c8f4ac.ttf";